import ReactTooltip from "react-tooltip";
import { ImgInfo } from '../../img'

const Tooltip = ({id = "", title = "", text = "" }) => {

    return (
        <div>
            <a data-tip data-for={id}>
                <ImgInfo />
            </a>
            < ReactTooltip className="tooltip-ihcr" id={id} place="top" type="light" effect='solid' data-for='global'>
                <div className="">
                    <div className="tooltip-header-ihcr">
                        <ImgInfo />
                        <p className="tooltip-header-elemnts-ihcr">{title}</p>
                    </div>
                    <hr />
                    <div className="tooltip-body-ihcr">
                        {text}
                    </div>
                </div>
            </ReactTooltip>
        </div>

    );
}

export { Tooltip }